<template>
  <div class="vh-100 overflow-hidden">
    <div class="app flex-row align-items-center h-100">
      <div class="container" style="max-width: 800px">
        <h4>{{ $t("Webportal.External.Login.Introduction") }}</h4>
        <p class="text-muted">
          {{ $t("Webportal.External.Login.Introduction.Description") }}
        </p>

        <b-row class="pt-3">
          <b-col md>
            <b-form-group
              :label="$t('Webportal.FirstName')"
              label-for="firstName"
            >
              <b-form-input
                autofocus
                trim
                id="firstName"
                v-model="externalUser.FirstName"
                @keyup.enter="continueClicked"
                v-validate="'required'"
                data-vv-name="FirstName"
              />
            </b-form-group>
          </b-col>
          <b-col md>
            <b-form-group
              :label="$t('Webportal.LastName')"
              label-for="lastName"
            >
              <b-form-input
                trim
                id="lastName"
                v-model="externalUser.LastName"
                @keyup.enter="continueClicked"
                v-validate="'required'"
                data-vv-name="LastName"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group :label="$t('Webportal.EmailAddress')" label-for="email">
          <b-form-input
            id="email"
            v-model="externalUser.Email"
            :state="isEmailValid"
            trim
            @keyup.enter="continueClicked"
            v-validate="'required|email'"
            data-vv-name="EMail"
          />
        </b-form-group>

        <b-form-group>
          <b-form-checkbox id="remember" v-model="remember">
            {{ $t("Webportal.External.Login.Remember") }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-button
            variant="primary"
            :disabled="!isFormValid"
            @click="continueClicked"
          >
            {{ $t("Webportal.Continue") }}
          </b-button>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: "ExternalLogin",

  data() {
    return {
      externalUser: {},
      remember: true,
    };
  },

  computed: {
    isEmailValid() {
      if (this.externalUser?.Email && this.validationFields["EMail"])
        return this.validationFields["EMail"].valid;
    },

    isFormValid() {
      return Object.keys(this.validationFields).every(
        (key) =>
          this.validationFields[key].valid === null ||
          this.validationFields[key].valid
      );
    },
  },

  mounted() {
    if (!this.$route.params.redirectTo) this.$router.push({ name: "notfound" });
  },

  methods: {
    continueClicked() {
      if (this.isEmailValid) {
        AuthenticationService.loginExternal(
          this.$route.params.redirectTo,
          this.externalUser,
          this.remember
        )
          .then(() => {
            let redirectTo = this.$route.params.redirectTo;
            // Remove sicc for security reasons
            if (redirectTo.query.sicc) delete redirectTo.query.sicc;
            this.$router.replace({
              path: redirectTo.path,
              query: redirectTo.query,
              replace: true,
            });
          })
          .catch((e) => {
            console.error(e)
            this.$router.push({ name: "error" });
          });
      }
    },
  },
};
</script>